import { useRequiredContext } from "@redotech/react-util/context";
import { RpcClientContext } from "@redotech/redo-customer-portal-shared/contexts/rpc";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orderReturnsQueryKey } from "./order-returns-query-key";

export function useCancelReturn(orderId?: string) {
  const rpcClient = useRequiredContext(RpcClientContext);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (returnId: string) => rpcClient.cancelReturn({ returnId }),
    onSuccess: () => {
      if (orderId) {
        void queryClient.invalidateQueries({
          queryKey: orderReturnsQueryKey(orderId),
        });
      }
    },
  });
}
